// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReflectionFormController from "./reflection_form_controller"
application.register("reflection-form", ReflectionFormController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import TypewriterController from "./typewriter_controller"
application.register("typewriter", TypewriterController)
